var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home"},[(_vm.$configuration.orderTypesEnabled)?_c('div',[_c('WCOrderTypes',{attrs:{"orderTypes":_vm.visibleOrderTypes}})],1):[(_vm.$configuration.ads)?_c('WCWebAds',{attrs:{"webAds":_vm.$configuration.ads}}):_vm._e()],_c('WCHomePage',{attrs:{"name":_vm.$configuration.store.name,"rows":_vm.$configuration.rows}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }